import Administracao from "./Administracao";
import Comercial from "./Comercial";
// import Suporte from "./Suporte";

export default {
  Administracao,
  Comercial,
  // Suporte,
};
